// extracted by css-extract-rspack-plugin
export default {"link":"content-editor-plugin-link-Link-link-0d3924cb"};